<template>
  <div class="py-2 px-4 overflow-hidden">
    <div class="flex justify-between" v-if="$route.params.type === '2'">
      <VButton class="px-4" @click="getReport('2')" :class="{'bg-gray-50' : type !== '2'}">همه</VButton>
      <VButton class="px-4" @click="getReport('6')" :class="{'bg-gray-50' : type !== '6'}">امروز</VButton>
    </div>

    <div class="flex justify-between border-b border-gray-600 py-2">
      <h1 class="text-sm">{{ report.displayName }}</h1>
      <span class="mt-1 text-sm">{{ report.reportTime + " " + report.reportDate }}</span>
    </div>

    <div class="flex justify-between rounded-lg bg-gray-800 text-white p-4 mt-4 text-sm shadow">
      <h1>{{ report.sumName + ': ' }}</h1>
      <span class="text-red-500">{{ $helper.priceFormatter(report.sum) }}</span>
    </div>

    <RangeSlider class="mt-8 mx-2" v-model="range" :max="max" :format="formatSlider" @change="updateReport" dir="ltr"/>

    <div class="flex justify-center rounded-lg bg-white mt-4 shadow p-4">
      <LoadingSpinner class="w-5" v-if="loading"/>

      <table class="table w-full text-sm divide-y divide-gray-400" v-else>
        <thead class="text-right">
        <tr>
          <th class="py-2">{{ report.colKeyDisplayName }}</th>
          <th>{{ report.colValueDisplayName }}</th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-400">
        <tr v-for="row in report.reportDetailDTO"
            :key="row.cplValue"
            @click="getDetails(row.colKey)">
          <td class="py-3">{{ row.colKey }}</td>
          <td class="py-3">{{ $helper.priceFormatter(row.colValue, false) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <VModal :show="modal.show" :title="modal.title" @click="modal.show = false">
    <div class="flex justify-center">
      <table class="table w-full text-xs divide-y divide-gray-400" v-if="details.length > 0">
        <thead class="text-right">
        <tr>
          <th class="py-2">مبلغ</th>
          <th>{{ details[0].colParam1DisplayName }}</th>
          <th>{{ details[0].colParam2DisplayName }}</th>
          <th>{{ details[0].colparam3DisplayName }}</th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-400">
        <tr v-for="row in details"
            :key="row.colValue"
            @click="showParam4Modal(row)">
          <td class="py-2">{{ $helper.priceFormatter(row.colValue, false) }}</td>
          <td class="py-2">{{ row.colParam1 }}</td>
          <td class="py-2">{{ row.colParam2 }}</td>
          <td class="py-2">{{ row.colparam3 }}</td>
        </tr>
        </tbody>
      </table>

      <LoadingSpinner class="w-5" v-else/>
    </div>

  </VModal>

  <VModal :show="modalParam4.show" :title="modalParam4.title" @click="modalParam4.show = false">
    <h1 class="text-center">{{ modalParam4.value }}</h1>
  </VModal>

</template>

<script>
import {getReport} from "@/API/API";
import VModal from "@/components/General/VModal";
import LoadingSpinner from "@/components/General/LoadingSpinner";
import RangeSlider from '@vueform/slider'
import VButton from "@/components/General/VButton";

export default {
  name: "ReportPage",
  components: {VButton, LoadingSpinner, VModal, RangeSlider},
  data() {
    return {
      loading: false,
      report: [],
      details: [],
      modal: {
        show: false,
        title: '',
      },
      modalParam4: {
        show: false,
        title: '',
        value: ''
      },
      range: [0, 8788],
      max: 100,
      type: this.$route.params.type
    }
  },
  created() {
    this.getReport()
  },
  methods: {
    async getReport(type) {
      this.type = type || this.type
      this.report = (await getReport(this.type)).data.result
      this.range = [this.report.min, this.report.max]
      this.max = this.report.max
    },
    async getDetails(id) {
      this.modal.show = true
      this.modal.title = id
      this.details = []
      this.details = (await getReport(this.$route.params.type, id)).data.result
    },
    async updateReport(range) {
      this.loading = true
      this.report = (await getReport(this.$route.params.type, '', range[0], range[1])).data.result
      this.loading = false
    },
    formatSlider(val) {
      return this.$helper.priceFormatter(val, false)
    },
    showParam4Modal(row) {
      if (row.colparam4) {
        this.modalParam4.show = true
        this.modalParam4.title = row.colparam4DisplayName
        this.modalParam4.value = row.colparam4
      }
    }
  }
}
</script>

<style>
@import "~@vueform/slider/themes/default.css";
</style>
